export function isValidPreferredName(value: string) {
  return /^[a-zA-Z ]*$/.test(value);
}
